import { render, staticRenderFns } from "./FleetTable.vue?vue&type=template&id=12c00110&scoped=true"
import script from "./FleetTable.vue?vue&type=script&lang=js"
export * from "./FleetTable.vue?vue&type=script&lang=js"
import style0 from "./FleetTable.vue?vue&type=style&index=0&id=12c00110&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c00110",
  null
  
)

export default component.exports